export default "__VITE_ASSET__DDzXh6vE__"